import { render, staticRenderFns } from "./rdExpertTeam.vue?vue&type=template&id=6db53471&scoped=true&"
import script from "./rdExpertTeam.vue?vue&type=script&lang=js&"
export * from "./rdExpertTeam.vue?vue&type=script&lang=js&"
import style0 from "./rdExpertTeam.vue?vue&type=style&index=0&id=6db53471&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db53471",
  null
  
)

export default component.exports